import React, { Component } from 'react';
class App extends Component {
  constructor() {
    super();
    this.state = {
      tunes: []
    }
  }
componentDidMount() {
    let dataURL = "http://test.hewick.co.uk/wp-json/wp/v2/tunes?_embed";
    fetch(dataURL)
      .then(res => res.json())
      .then(res => {
        this.setState({
          tunes: res
        })
      })
  }
render() {
    let tunes = this.state.tunes.map((tune, index) => {
      return <div class="col col-3" key={index}>
      
      <div class="featured-image" style={{ backgroundImage: 'url(' + tune.acf.audio_image.sizes['half-page'] + ')'}}></div>
      <p><strong>Title:</strong> {tune.title.rendered}</p>
      <p><audio controls> <source src={tune.acf.audio_file} type="audio/mpeg" /></audio></p>
      <div><strong>Description:</strong><div dangerouslySetInnerHTML={ {__html: tune.content.rendered} } /></div>
      </div>
    });
return (
      <div class="wrapper">
        {tunes}
      </div>
    )
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js